package feature.offerBanner.event

class OfferBannerEvent {
    companion object {
        const val CREATE = "CREATE_OFFER_BANNER"
        const val UPDATE = "UPDATE_OFFER_BANNER"
        const val RETRIEVE = "RETRIEVE_OFFER_BANNER"
        const val DELETE = "DELETE_OFFER_BANNER"
    }

}